import { render, staticRenderFns } from "./inflections-supp-table-wide.vue?vue&type=template&id=bc8244ea&"
import script from "./inflections-supp-table-wide.vue?vue&type=script&lang=js&"
export * from "./inflections-supp-table-wide.vue?vue&type=script&lang=js&"
import style0 from "./inflections-supp-table-wide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc8244ea')) {
      api.createRecord('bc8244ea', component.options)
    } else {
      api.reload('bc8244ea', component.options)
    }
    module.hot.accept("./inflections-supp-table-wide.vue?vue&type=template&id=bc8244ea&", function () {
      api.rerender('bc8244ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/inflections-supp-table-wide.vue"
export default component.exports